<template>
  <div class="live-card">
    <div class="title-container mb-1">
      <div class="card-title">
        <h3 data-text="Cards">
          Live <span>{{ cardTitle }}</span>
        </h3>
      </div>
      <div class="list-more">
        <nuxt-link :to="redirectToMore()" class="text-decoration-none">
          More ...
        </nuxt-link>
      </div>
    </div>
    <div class="grid-button">
      <template v-for="(card, i) in gamesArray">
        <nuxt-link
          :key="card.id + i"
          :to="getGameLink(card.id)"
          class="btn_cards name-image v-btn v-btn--is-elevated v-btn--has-bg v-btn--router theme--dark v-size--default"
        >
          <span class="v-btn__content">
            <span class="name manage-overflow-name f8">{{ card.title }}</span>
            <span class="image">
              <a href="/live-cards/56767" class="">
                <div class="v-image v-responsive theme--dark">
                  <div
                    class="v-responsive__sizer"
                    style="padding-bottom: 96.0265%"
                  ></div>
                  <div
                    class="v-image__image v-image__image--cover"
                    :style="{
                      backgroundImage: `url(${getImage(card.img)})`,
                      backgroundPosition: 'center center'
                    }"
                  ></div>
                  <div class="v-responsive__content" style="width: 20px"></div>
                </div>
              </a>
            </span>
          </span>
        </nuxt-link>
      </template>
      <!-- <a
        href="/live-cards/56767"
        class="btn_cards name-image v-btn v-btn--is-elevated v-btn--has-bg v-btn--router theme--dark v-size--default"
      >
        <span class="v-btn__content">
          <span class="name manage-overflow-name f8">Teenpatti</span>
          <span class="image">
            <a href="/live-cards/56767" class="">
              <div class="v-image v-responsive theme--dark">
                <div
                  class="v-responsive__sizer"
                  style="padding-bottom: 96.0265%"
                ></div>
                <div
                  class="v-image__image v-image__image--cover"
                  style="
                    background-image: url('https://d1znekj6k2v12k.cloudfront.net/cardscasino/teenpatti.webp?auto=compress&amp;lossless=false&amp;fm=webp&amp;q=80&amp;fit=crop&amp;w=40');
                    background-position: center center;
                  "
                ></div>
                <div class="v-responsive__content" style="width: 20px"></div>
              </div>
            </a>
          </span>
        </span>
      </a> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiveCards',
  props: {
    cardTitle: { type: String, default: 'Cards', required: true },
    gamesArray: { type: Array, default: () => [], required: true }
  },
  methods: {
    getImage(img) {
      return require(`@/assets/images/live-games/${img}`)
    },
    getGameLink(id) {
      if (this.cardTitle === 'Cards') return `/live-cards/${id}`
      return `markets/live-casino/${id}`
    },
    redirectToMore() {
      if (this.cardTitle === 'Cards') return '/live-cards'
      return 'markets/live-casino'
    }
  }
}
</script>

<style lang="scss" scoped>
.live-card {
  width: 100%;
  border: 1px solid #474747;
  margin-top: 10px;
  border-radius: 16px;
  padding: 8px;
}
.title-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-title {
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  > h3 > span {
    color: var(--v-primary-base);
  }
}
.list-more a {
  font-size: 12px;
}
.grid-button {
  position: relative;
  display: grid;
  gap: 0.875rem;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 8px;
}
.v-btn {
  height: 30px;
}
.grid-button .btn_cards:nth-child(odd),
.grid-button .btn_cards:nth-child(odd),
.grid-button .btn_cards:nth-child(odd) {
  background: linear-gradient(#130c2d, #130c2d) padding-box,
    linear-gradient(to left, #1904e5, #fab2ff) border-box;
  box-shadow: #8154f1 0px -1px 5px 2px;
}
.grid-button .btn_cards:nth-child(even),
.grid-button .btn_cards:nth-child(even),
.grid-button .btn_cards:nth-child(even) {
  background: linear-gradient(#130c2d, #130c2d) padding-box,
    linear-gradient(to left, #f37415, #ff0000) border-box;
  box-shadow: #f37415 0px -1px 5px 2px;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 30px;
  min-width: 64px;
  padding: 0px 8px !important;
  border-radius: 16px;
  border: 2px solid transparent;
}
.v-btn__content {
  justify-content: space-evenly;
  letter-spacing: 0em;
}
.manage-overflow-name {
  text-transform: capitalize;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .manage-overflow-name {
    width: calc(100% - 30px);
  }
}
@media (min-width: 768px) {
  .grid-button {
    gap: 1rem;
  }
  .v-btn:not(.v-btn--round).v-size--default {
    height: 50px;
    min-width: 64px;
    padding: 0px 8px !important;
    border-radius: 50em;
    border: 2px solid transparent;
  }
  .manage-overflow-name {
    font-size: 0.875rem !important;
  }
}
</style>
